import React from "react";
import styles from "./FoundationalStage.module.css";
import { cleanLines, stripBoldTitle } from "../OnboardingStage/utils";

const parseIssueBullet = (text = "") => {
  const normalized = String(text || "").trim();
  const match = normalized.match(/^(.+?):\s*(\d+)\s*URLs?\s*\((.+)\)\s*$/i);
  if (!match) {
    return { label: normalized, total: "", breakdown: [] };
  }

  const breakdown = match[3]
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

  return {
    label: match[1].trim(),
    total: match[2].trim(),
    breakdown,
  };
};

const parseCrawlAndIndexing = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const intro = [];
  const bullets = [];
  const actions = [];
  let issueLabel = "";
  let phase = "intro";

  lines.forEach((line) => {
    if (/^urls with issues:\s*$/i.test(line)) {
      issueLabel = "URLs with issues";
      if (phase === "intro") phase = "bullets";
      return;
    }

    if (/^[•\-*]\s/.test(line)) {
      phase = "bullets";
      bullets.push(line.replace(/^[•\-*]\s*/, ""));
    } else if (phase === "bullets" && !line.startsWith("URLs with")) {
      actions.push(line);
    } else {
      if (phase === "intro") intro.push(line);
      else actions.push(line);
    }
  });

  return {
    intro: intro.join(" ").trim(),
    issueLabel,
    bullets,
    parsedBullets: bullets.map(parseIssueBullet),
    action: actions.join(" ").trim(),
  };
};

const CrawlAndIndexing = ({ markdown = "" }) => {
  const { intro, issueLabel, bullets, parsedBullets, action } =
    parseCrawlAndIndexing(markdown);
  if (!intro && !bullets.length && !action) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Crawl & Indexing</h3>
      {intro ? (
        <div className={styles.card}>
          <p className={styles.paragraph}>{intro}</p>
        </div>
      ) : null}
      {bullets.length ? (
        <div className={styles.summaryCard}>
          <h4 className={styles.summaryTitle}>{issueLabel || "URLs with issues"}</h4>
          <div className={styles.issueList}>
            {parsedBullets.map((item, idx) => (
              <div key={`${item.label}-${idx}`} className={styles.issueItem}>
                <div className={styles.issueHead}>
                  <p className={styles.issueLabel}>{item.label}</p>
                  {item.total ? (
                    <span className={styles.issueCount}>{item.total} URLs</span>
                  ) : null}
                </div>
                {item.breakdown.length ? (
                  <div className={styles.issueChips}>
                    {item.breakdown.map((chip, chipIdx) => (
                      <span key={`${chip}-${chipIdx}`} className={styles.issueChip}>
                        {chip}
                      </span>
                    ))}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}
      {action ? (
        <div className={styles.actionCard}>
          <p className={styles.actionTitle}>Execution Plan</p>
          <p className={styles.actionText}>{action}</p>
        </div>
      ) : null}
    </div>
  );
};

export default CrawlAndIndexing;
